<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        海大智龙与上海船舶研究设计院签订集装箱船配载仪合作研发合同
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
           <div class="div-text-left news-Regular-14b6">
            <span>2020-05-19</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
           </div>
      <div class="div-line  divcss5"></div>
      <div class="div-row div-bottom10">
        <div class="  div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news18/1.png" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom10">
          <p class="indentation">
         5月19日上午，上海船舶研究设计院党委书记兼行政负责人王麟、副院长周志勇、创新中心副总监李鑫、能源技术部主任陆晟、经营管理部主任李昆仑、综合技术部副主任曹阳、经营管理部高级经理陈彦希一行7人到大连海事大学及大连海大智龙科技有限公司进行调研。大连海事大学校党委书记郑少南、校长孙玉清、副校长王小勇、科技处处长弓永军、船舶电气工程学院教授王国峰、发展规划与质量管理处副处长贾石岩及大连海大智龙科技有限公司董事长尹勇参加了座谈。
        </p>  
      </div>
      <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news18/2.png" />
          </div>
        </div>
      </div>
   <div class="div-row div-bottom10">
          <p class="indentation">
        会上大连海大智龙科技有限公司与上海船舶研究设计院举行了集装箱船配载仪开发合同签约仪式。双方长期以来在项目联合攻关、科技产业化协同创新等方面一直保持深入合作。自2013年起，大连海事大学就开始和与上海船舶研究设计院联合开发配载仪系统，到目前为止，已经完成散货船配载仪、液货船配载仪两款产品的研制，集装箱船配载仪的开发也完成90%以上，目前已经通过CCS，BV，DNV船级社的认可。该配载系统受到了船员及船东的一致好评。在双方的推动下，散货船和液货船配载仪目前正在申请LR船级社的型式认可。
        </p>
      </div>
         <div class="div-row div-bottom10">
        <div class=" div-top box2">
                 <div class="div-margin ">
             <img src="../../../assets/images/news18/3.png" />
          </div>
        </div>
      </div>
   <div class="div-row div-bottom10">
          <p class="indentation">
       下午，上海船舶研究设计院一行到公司进行参观，公司董事长尹勇介绍了公司在无人船舶系统及设备关键技术等方面所取得的阶段性成果。未来双方将拓展合作领域，在智能货物管理、智能船舶避碰、无人船远程控制中心等领域实现更广泛合作。
         </p>
      </div>
         <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news18/4.png" />
          </div>
        </div>
      </div>
        <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news18/5.png" />
      
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }
  img {
    vertical-align: middle;
    border-style: none;
    width: 100%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news18.vue